$.ajaxSetup({
    headers: { 'X-CSRF-Token' : $('meta[name=_token]').attr('content') }
});


function createErrorHTML(textToDisplay)
{
	var parsed = JSON.parse(textToDisplay);
	var HTMLOut = "";

	if (parsed.email)
		HTMLOut += "<li><b>Email: </b>" + parsed.email[0] + "</li>";
	if (parsed.password)
		HTMLOut += "<li><b>Password: </b>" + parsed.password[0] + "</li>";
	if (parsed.name)
		HTMLOut += "<li><b>Name: </b>" + parsed.name[0] + "</li>";

	return '<div class="alert alert-danger" role="alert">' + HTMLOut + "</div>";
}


$( document ).ready(function() {

    /** Send a login request */
    $('#loginbutton').on('click', function(e)
    {
        e.preventDefault();

        $.ajax({
            url: '/user/login',
            type: 'post',
            data: $('#loginform').serialize(),
            success: function (response)
            {
                window.location.reload();
            },
            error: function (response)
            {
                $("#loginerror").show();
            },
        });
    });

    /** Send a request to update a password */
    $('#update-password-button').on('click', function(e)
    {
        e.preventDefault();
        $.ajax({
            url: '/user/change-password',
            type: 'post',
            data: "password=" + $('#passwordChange').val() + "&password2=" + $('#passwordChange2').val(),
            success: function (response)
            {
                console.log(response);
            },
            error: function (response)
            {
                var HTMLOut = createErrorHTML(response.responseText);
                console.log( '<div class="alert alert-danger" role="alert">' + HTMLOut + "</div>" );
            },
        });
    });

    /** Send a request to register for an account */
    $('#register-button').on('click', function(e)
	{
		e.preventDefault();

		$.ajax({
			url: '/user/register',
			type: 'post',
			data: $('#registerform').serialize(),
			success: function (response)
			{
				window.location.href = "/shop";
			},
			error: function (response)
			{
				$("#errors").html(createErrorHTML(response.responseText));
			},
		});
	});

    /** Send a request for a password reset */
	$('#forgotbutton').on('click', function (e) {
		e.preventDefault();
		$('#forgotbutton').text("").html("<i class='fa fa-circle-o-notch fa-spin fa-fw'></i>");

		$("#forgoterror").hide();

		$.ajax({
			url: '/user/forgot',
			type: 'post',
			data: $('#forgotform').serialize(),
			success: function (response) {
				$("#forgotsuccess").show();
				$("#forgotdiv").hide();
			},
			error: function (response) {
				$("#forgoterror").show();
				$('#forgotbutton').text("").html("Request Password Reset");
				console.log(response.responseText);
			},
		});
	});


	/** Sets a new password from a forgot */
	$('#resetbutton').on('click', function (e) {
		e.preventDefault();
		$('#resetbutton').text("").html("<i class='fa fa-circle-o-notch fa-spin fa-fw'></i>");

		$("#reseterror").hide();

		$.ajax({
			url: '/user/reset',
			type: 'post',
			data: $('#resetform').serialize(),
			success: function (response) {
				$("#resetsuccess").show();
				$("#resetdiv").hide();
				console.log(response);
			},
			error: function (response) {
				$("#reseterror").show();
				$("#reseterror").text(response.responseText);
				$('#resetbutton').text("").html("Request Password Reset");
				console.log(response.responseText);
			},
		});
	});

});
